import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-left font-pt-root mx-8 mt-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " このサービスは、手軽に Nounish NFT を手に入れていただくために作ったオークション形式のミント・サイトです。 「ダッチオークション」と呼ばれる方式で、新たにミントしたNFTを、まずは1ETHで売り出し、 時間とともに徐々に値段を下げ、買い手がついたところで、次のNFTをミントします。 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" このオークションでの売り上げは、全て 「"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://nounsfes.org",
    class: "underline"
  }, "Nouns Art Festival (NounsFes)"),
  /*#__PURE__*/_createTextVNode("」 の運営(主に賞金)に当てられます。NounsFesは、非営利なオンライン映画祭で、愛と平和とSDGsをテーマにした短編映像を表彰するものです。 ここで発行されたNFTを持った方々には、審査員として参加していただくことを予定しています。 ")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "text-left font-pt-root mx-8 mt-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " This is a minting service for people who want to have affordable Nounish NFTs. A newly minted NFT will be priced at 1ETH initiallly, and the price will go down gradually until somebody purchases it (Dutch Auction). ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" All the proceed from this auction will be used for "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://nounsfes.org",
    class: "underline"
  }, "Nouns Art Festival (NounsFes)"),
  /*#__PURE__*/_createTextVNode(" , which is a non-profit online video festival, honoring short videosm which promotes love, pease and SDGs. We have a plan to create a mechanism for NFT holders to participate as judges. ")
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.lang === 'ja')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
}